module.exports = __webpack_public_path__ + "ea575d355603ac8f207da77a38798232.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/hairbrush.png
// module id = 2848
// module chunks = 0